import React from 'react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { tools } from '../../data/tools';
export function Tools() {
  return <section className="bg-white px-5 py-16 sm:py-20" aria-label="Practical clinical tools" data-id="element-351" data-mp="2hk1cz7kwcyr4">
      <div className="mx-auto max-w-4xl" data-id="element-352" data-mp="2dig6q52vbipw">
        <SectionHeading kicker="Practical clinical tools included" title="Turn what you study into an organized reference system" subtitle="Alongside the six volumes, you’ll receive access to five practical learning resources." data-id="element-353" data-mp="2dhejz3chp7sc" />

        <ol className="mt-10 space-y-3" data-id="element-354" data-mp="1yta8ajbutwj2">
          {tools.map(tool => <li key={tool.number} className="flex gap-4 rounded-2xl bg-mist p-5 sm:items-center sm:gap-6 sm:p-6" data-id="element-355" data-mp="1yr78x8otar1o">
              <span className="font-display text-4xl font-black leading-none text-electric sm:text-5xl" data-id="element-356" data-mp="1psvjh9zolzat">{tool.number}</span>
              <div data-id="element-357" data-mp="1ktin9ymx7fvk">
                <h3 className="font-display text-lg font-extrabold leading-snug text-navy-950" data-id="element-358" data-mp="1kv3hfn5bowsw">{tool.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-ink/70" data-id="element-359" data-mp="157wlxl7m28b4">{tool.description}</p>
              </div>
            </li>)}
        </ol>

        <p className="mt-8 text-center text-lg font-semibold text-navy-950" data-id="element-360" data-mp="w9b8g4gzxjh7">
          Everything is organized to make your clinical learning more practical.
        </p>

        <div className="mt-8" data-id="element-361" data-mp="1080ns2llhb3h">
          <CtaButton label="Get all 6 volumes + clinical tools" data-id="element-362" data-mp="1nzphnne2e7mj" />
        </div>
      </div>
    </section>;
}